// extracted by mini-css-extract-plugin
export var main = "about-module--main--yta6H";
export var root = "about-module--root--csW26";
export var team = "about-module--team--OcSOo";